import { motion } from 'framer-motion';
import { useParams } from 'react-router-dom';

import { BuildingReadModel } from '@client/api';
import { PageDetailContent } from '@client/toolkit';
import { useBuildingPackages } from '../../../../../hooks/useBuildingPackages';

import { useSpace } from '../../../context/space-context';
import { AccountingPrincipleCard } from '../../../components/accounting-principle-card/accounting-principle-card.component';
import { LoanCard } from '../../../components/loan-card/loan-card.component';
import { ValuationCard } from '../../../components/valuation-card/valuation-card.component';

export function BuildingFinancingTabRoute() {
  const { buildingId } = useParams<{ buildingId: string }>();

  // The accounting-principle setting is part of the Portfolio Standard package (matching the
  // upcoming "Gjeld & soliditet" report); lower tiers implicitly keep the NGAAP default.
  const { space: building } = useSpace();
  const { hasPortfolioStandard } = useBuildingPackages((building as BuildingReadModel | undefined)?.packages);

  return (
    <PageDetailContent align="left">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          opacity: { ease: 'linear', duration: 0.2 },
          y: { ease: 'easeInOut', duration: 0.4 },
        }}
        className="space-y-2"
      >
        {hasPortfolioStandard && <AccountingPrincipleCard buildingId={buildingId} />}
        <LoanCard buildingId={buildingId} />
        <ValuationCard buildingId={buildingId} />
      </motion.div>
    </PageDetailContent>
  );
}
